/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Click_On_Plan_To_Add_RoomInputs */



/**
* | output |
* | --- |
* | "Click on the plan to add the room" |
*
* @param {Click_On_Plan_To_Add_RoomInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const click_on_plan_to_add_room = /** @type {((inputs?: Click_On_Plan_To_Add_RoomInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Click_On_Plan_To_Add_RoomInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Click on the plan to add the room")
	return /** @type {LocalizedString} */ ("Cliquer sur le plan pour ajouter la pièce")
});